import { useState } from 'react';
import {
  filter as lfilter,
  compose as lcompose,
  negate as lnegate,
  eq as leq,
  map as lmap,
} from 'lodash/fp';
import {
  IRequestDetails,
  IApiCallStatus,
  getRequestByRequestId,
  useUserContext,
  getApproverRequestByRequestId,
  getAdminRequestByRequestId,
} from '../common';
import { path } from 'rambda';
import { fold } from 'fp-ts/lib/Either';
import { RequestStatusType } from '.';

export interface IMoreRequestData {
  requestId: number;
  details?: IRequestDetails;
  callStatus: IApiCallStatus;
}

export function useGetMoreRequestData({
  requestStatusType,
}: {
  requestStatusType: RequestStatusType;
}) {
  const [moreRequestData, setMoreRequestData] = useState<IMoreRequestData[]>(
    []
  );

  const { user } = useUserContext();

  const requestApi = (requestStatusType: RequestStatusType) =>
    requestStatusType === 'AdminRequestApproval'
      ? getAdminRequestByRequestId
      : requestStatusType === 'MemberRequestApproval' ||
        requestStatusType === 'MemberRequestStatus'
      ? getApproverRequestByRequestId
      : getRequestByRequestId;

  const add = (requestId: number) => {
    setMoreRequestData(a => [...a, { requestId, callStatus: null }]);

    requestApi(requestStatusType)(user!.icam!.headers)(requestId)
      .then(
        fold<unknown, IRequestDetails, void>(
          a => console.error(a), // TODO implement
          b =>
            setMoreRequestData(
              lmap<IMoreRequestData, IMoreRequestData>(a =>
                a.requestId === requestId
                  ? { ...a, callStatus: true, details: b }
                  : a
              )
            )
        )
      )
      .catch(() =>
        setMoreRequestData(
          lmap<IMoreRequestData, IMoreRequestData>(a =>
            a.requestId === requestId ? { ...a, callStatus: false } : a
          )
        )
      );
  };

  const remove = (requestId: number) =>
    setMoreRequestData(a => [
      ...lfilter<{
        requestId: number;
        details?: IRequestDetails;
        callStatus: IApiCallStatus;
      }>(lcompose(lnegate(leq(requestId)), path('requestId')))(a),
    ]);

  return { moreRequestData, add, remove };
}
